import Vapi from "@vapi-ai/web";
import { useEffect, useRef, useState } from "react";

const ASSISTANT_ID = "1efcd159-c62d-49fc-9cde-1af4da1415b7";
const PUBLIC_KEY = "7511508a-40f9-4830-97f6-ffa344ac0d8d";

export function useCallCallie() {
  const vapiRef = useRef(null);
  const [callActive, setCallActive] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    const vapi = new Vapi(PUBLIC_KEY);
    vapiRef.current = vapi;

    vapi.on("call-start", () => { setCallActive(true); setStatus("Connected"); });
    vapi.on("call-end", () => { setCallActive(false); setStatus(""); });
    vapi.on("speech-start", () => setStatus("Callie is speaking..."));
    vapi.on("speech-end", () => setStatus("Connected"));
    vapi.on("error", (e) => {
      console.error(e);
      setCallActive(false);
      setStatus("Something went wrong. Try again.");
    });

    return () => {
      vapi.stop();
    };
  }, []);

  function toggle() {
    if (!vapiRef.current) return;
    if (callActive) {
      vapiRef.current.stop();
    } else {
      setStatus("Connecting...");
      vapiRef.current.start(ASSISTANT_ID);
    }
  }

  return { toggle, callActive, status };
}
